import { render } from "./IncomeRow.vue?vue&type=template&id=0b76d886&scoped=true"
import script from "./IncomeRow.vue?vue&type=script&lang=js"
export * from "./IncomeRow.vue?vue&type=script&lang=js"

import "./IncomeRow.vue?vue&type=style&index=0&id=0b76d886&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b76d886"]])

export default __exports__